export interface Stats {
  total: number;
  pillars: number;
  challenges: number;
  criteria: number;
  kpis: number;
  drivers: number;
  with_rubrics: number;
}

export function StatsGrid({ stats }: { stats: Stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4 mb-4 shrink-0">
      <StatCard label="Total" value={stats.total} />
      <StatCard
        label="L1 Pillars"
        value={stats.pillars}
        className="text-chart-1"
      />
      <StatCard
        label="L2 Challenges"
        value={stats.challenges}
        className="text-chart-2"
      />
      <StatCard
        label="L3 Criteria"
        value={stats.criteria}
        className="text-chart-3"
      />
      <StatCard label="L4 KPIs" value={stats.kpis} className="text-chart-4" />
      <StatCard
        label="L5 Drivers"
        value={stats.drivers}
        className="text-chart-5"
      />
      <StatCard
        label="With Rubrics"
        value={stats.with_rubrics}
        className="text-chart-6"
      />
    </div>
  );
}

function StatCard({
  label,
  value,
  className,
}: {
  label: string;
  value: number;
  className?: string;
}) {
  return (
    <div className="bg-card rounded-lg p-4 shadow">
      <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
        {label}
      </div>
      <div
        className={`text-2xl font-bold mt-1 ${className ?? "text-foreground"}`}
      >
        {value}
      </div>
    </div>
  );
}
